module.exports = __webpack_public_path__ + "img/logo.06f9b73f.png";